import styled from 'styled-components';
import { motion } from 'framer-motion';

const Divider = styled.div`
  border-top: 1px dotted #ccc4d2;
  width: 100%;
  height: 1px;
  margin: 15px 0 5px;
  display: block;
`;

const ContentContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  width: 100%;
  &:nth-child(2) {
    width: 100%;
  }
  .button-tooltip.active {
    margin-top: 5px !important;
  }
`;

const LoadingWrapper = styled.div`
  margin-top: 15px;
`;

export { ContentContainer, Divider, LoadingWrapper };
